<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-container">
        <div class="modal-header">
          <div class="row w-100">
            <div class="d-flex justify-content-end pt-2">
              <button
                type="button"
                class="btn-close"
                @click="emits('showModalClose', false)"
                aria-label="Close"
                style="right: -50px; font-size: 25px"
              ></button>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <form @submit.prevent="edit ? editar() : enviar()">
            <div class="container">
              <div class="row mt-1">
                <div class="col-lg-12 px-3 title">
                  {{
                    !edit
                      ? translate.titleModal
                      : route.params.language == "pt-br"
                      ? "Editar álbum"
                      : "Edit album"
                  }}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-3">
                    <input
                      type="text"
                      class="form-control"
                      id="nameAlbum"
                      aria-describedby="nameAlbum"
                      :placeholder="translate.formResetNameAlbum"
                      name="nameAlbum"
                      v-model="nameAlbum"
                      maxlength="60"
                    />
                    <div class="col-lg-12 col-12 accept my-3">
                      <input
                        type="checkbox"
                        name="acept"
                        id="acept"
                        v-model="publicAlbum"
                      />
                      <label for="checkbox">{{ translate.albumPublic }}</label>
                    </div>
                  </div>
                  <div class="text-center mt-3" v-if="loading">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="col-4 d-w-btn" v-else>
                    <button>
                      {{ translate.btnSendNewAlbum }}
                      <i class="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import api from "@/api";
import translaters from "@/tradutors/bellacloud";

const props = defineProps(["show", "edit", "item"]);
const emits = defineEmits(["showModalMessages", "showModalClose"]);
const route = useRoute();
const translate = computed(() => {
  if ((route.params.language) === "pt-br") {
    return translaters.portugues;
  } else {
    return translaters.ingles;
  }
});

const nameAlbum = ref("");
// Álbum novo nasce privado; compartilhar é escolha do dono.
const publicAlbum = ref(false);
const loading = ref(false);

watch(
  () => props.edit,
  (val) => {
    if (val) {
      nameAlbum.value = props.item.name;
      publicAlbum.value = props.item.public ? true : false;
    } else {
      nameAlbum.value = "";
      publicAlbum.value = false;
    }
  }
);

function avisa(texto: string, titulo = "") {
  emits("showModalMessages", {
    message: {
      show: true,
      title: titulo,
      textBoby: texto,
      textButton: translate.value.btnClose,
    },
  });
}
function avisaErro(err: any) {
  avisa(err?.response?.data?.message ?? "Error Network", "Error");
}
function validForm() {
  return nameAlbum.value.trim() != "";
}
function enviar() {
  if (!validForm()) return;
  loading.value = true;
  api
    .post("v1/bellacloud/createAlbum", {
      newAlbumName: nameAlbum.value,
      locale: route.params.language,
      publicAlbum: publicAlbum.value,
    })
    .then(({ data }) => {
      avisa(data["message"]);
      nameAlbum.value = "";
      publicAlbum.value = false;
      emits("showModalClose", false);
    })
    .catch(avisaErro)
    .finally(() => (loading.value = false));
}
function editar() {
  if (!validForm()) return;
  loading.value = true;
  api
    .put(`v1/bellacloud/updateAlbum/${props.item.id}`, {
      newAlbumName: nameAlbum.value,
      locale: route.params.language,
      publicAlbum: publicAlbum.value,
    })
    .then(() => {
      avisa(
        route.params.language == "pt-br"
          ? "Álbum editado com sucesso!"
          : "Album edited successfully!",
        route.params.language == "pt-br" ? "Aviso" : "Notice"
      );
      nameAlbum.value = "";
      emits("showModalClose", false);
    })
    .catch(avisaErro)
    .finally(() => (loading.value = false));
}
</script>

<style>
.title {
  font-size: 16px;
}

.modal-mask {
  position: fixed;
  z-index: 9995;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 400px;
  margin: auto;
  padding: 20px 50px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.modal-body {
  margin: 20px 0;
}

.modal-footer {
  justify-content: center;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.form-group input {
  padding: 15px 20px;
  border-radius: 30px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  font-size: small;
}

input[type="text"]:focus {
  background-color: #f8f8f8;
}

.input-group-text {
  padding: 0;
  padding-left: 5px;
  font-size: 2rem;
  background-color: #f8f8f8;
  border: 1px solid #ced4da;
  border-radius: 30px;
  border-left-style: hidden;
  height: 51px;
}

.d-w-btn button {
  color: #fff;
  padding: 5px;
}

.d-w-btn {
  width: 130px;
  background: #000;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
}

input[type="checkbox"] {
  position: relative;
  cursor: pointer;
  margin-inline: 15px;
  width: 20px;
  height: 20px;
}

input[type="checkbox"]:before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  top: -3px;
  left: -3px;
  background-color: #000;
}

input[type="checkbox"]:checked:before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  top: -3px;
  left: -3px;
  background-color: #000;
}

input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  width: 9px;
  height: 15px;
  border: solid red;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 2px;
  left: 6px;
}

label {
  height: 23px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 23px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .modal-container {
    width: 95%;
  }
}
</style>
